import JSEncrypt from 'jsencrypt'

const RSA_KEY_BASE64 =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDSovT1rrwzrGoMCFb6z8e+5lzVdAD5o8krGIwdfxrVE2OnMijUZdkQk7etPJvZ2JOVXghthAGUUJkDUE8n2ZMNFKPjMrQJI49ewVzqWOKOvgU6Iu60Sn0xpeietP1wWXBkszdV1WfNBJUo2hhPDnIPMGzzdfLW5rMu+tczeUriJQIDAQAB'

// 加密方法
export default class Encrypt {
  static produce(msg) {
    const jse = new JSEncrypt()
    jse.setPublicKey(`-----BEGIN PUBLIC KEY-----
    ${RSA_KEY_BASE64}
    -----END PUBLIC KEY-----`)
    return jse.encrypt(msg)
  }
}
